/**
 * @generated SignedSource<<8de1ee1d52930efd34be75fcbdee3c87>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type richTextField_updateWorkItemFieldsActionRenderer$data = {
  readonly fieldId: string;
  readonly name: string;
  readonly richText: {
    readonly adfValue: {
      readonly convertedPlainText: {
        readonly isTruncated: boolean | null;
        readonly plainText: string | null;
      } | null;
    } | null;
  } | null;
  readonly " $fragmentType": "richTextField_updateWorkItemFieldsActionRenderer";
};
export type richTextField_updateWorkItemFieldsActionRenderer$key = {
  readonly " $data"?: richTextField_updateWorkItemFieldsActionRenderer$data;
  readonly " $fragmentSpreads": FragmentRefs<"richTextField_updateWorkItemFieldsActionRenderer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "richTextField_updateWorkItemFieldsActionRenderer",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "fieldId"
    },
    {
      "kind": "ScalarField",
      "name": "name"
    },
    {
      "concreteType": "JiraRichText",
      "kind": "LinkedField",
      "name": "richText",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraADF",
          "kind": "LinkedField",
          "name": "adfValue",
          "plural": false,
          "selections": [
            {
              "concreteType": "JiraAdfToConvertedPlainText",
              "kind": "LinkedField",
              "name": "convertedPlainText",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "plainText"
                },
                {
                  "kind": "ScalarField",
                  "name": "isTruncated"
                }
              ]
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraRichTextField"
};

(node as any).hash = "4be08a78c6400b4c754e9f0598a9d9a8";

export default node;
